import { createContext } from "react";

export const themeContext = createContext(false);
export const loaderContext = createContext();
